import { config as AWSConfig, S3 } from 'aws-sdk';

AWSConfig.update({
  region: 'us-east-1',
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
});

const s3 = new S3();

class AWSHelper {
  static upload2S3(params) {
    return new Promise((resolve, reject) => {
      s3.upload(params, (err, data) => {
        if (err) reject(err);
        resolve(data);
      });
    });
  }

  static getSignedUrl(params) {
    return s3.getSignedUrl('getObject', params);
  }

  static removeFromS3(params) {
    return new Promise((resolve, reject) => {
      s3.deleteObject(params, (err, data) => {
        if (err) reject(err);
        resolve(data);
      });
    });
  }
}

export default AWSHelper;
